/* angular:styles/component:css;40f7ef355c3c711d88f76281fb4fa0ed1dd0ba99f2ddeaca459f6ddda93ed755;/vercel/path0/src/app/datepicker/datepicker-ita/datepicker-ita.component.ts */
.custom-day {
  text-align: center;
  padding: 0.185rem 0.25rem;
  display: inline-block;
  height: 2rem;
  width: 2rem;
}
.ngb-dp-day.hidden {
  cursor: default;
  display: block !important;
}
.ngb-dp-day .hidden {
  display: block !important;
  visibility: hidden !important;
}
.custom-day.focused {
  background-color: #e6e6e6;
}
.custom-day.range,
.custom-day:hover {
  background-color: rgb(2, 117, 216);
  color: white;
}
.custom-day.faded {
  background-color: rgba(2, 117, 216, 0.5);
}
/*# sourceMappingURL=datepicker-ita.component.css.map */
